@if (stateService.isVisible()) {
  <ef-toast
    [title]="stateService.title()"
    [description]="stateService.description()"
    [type]="stateService.type()"
    (onHide)="stateService.hide()"
  ></ef-toast>
}
